import { forwardRef, type ComponentPropsWithoutRef, type Ref } from "react";
import {
  Link as RouterLink,
  type LinkProps as RouterLinkProps,
} from "react-router-dom";

// Compat shim for legacy code that imported `Link` from `next/link`. The
// legacy call shape is `<Link href="/path">…</Link>`, which we forward to
// `react-router-dom`'s `<Link to="/path">…</Link>`. Anything else
// (className, children, onClick, target, etc.) passes through untouched.

type AnchorAttrs = Omit<ComponentPropsWithoutRef<"a">, keyof RouterLinkProps>;
type Props = AnchorAttrs &
  Omit<RouterLinkProps, "to"> & {
    href: string;
  };

const LinkImpl = forwardRef(function Link(
  { href, ...rest }: Props,
  ref: Ref<HTMLAnchorElement>,
) {
  return <RouterLink ref={ref} to={href} {...rest} />;
});

export default LinkImpl;
